import { useCallback, useEffect } from 'react';
import { SnackbarKey, useSnackbar } from 'notistack';

import handleRetryToast from '@utils/handleRetryToast';

interface Props {
  isReady: boolean;
  isLoading: boolean;
  error: string | false;
  handleFetch: () => void;
}

const useFetchLookupData = ({ isReady, isLoading, error, handleFetch }: Props): void => {
  const { closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (!isReady && !isLoading && !error) handleFetch();
  }, [isReady, isLoading, error, handleFetch]);

  const handleRetry = useCallback(
    (snackbarId: SnackbarKey) => {
      handleFetch();
      closeSnackbar(snackbarId);
    },
    [handleFetch, closeSnackbar],
  );

  useEffect(() => {
    if (error) handleRetryToast(error, handleRetry);
  }, [error, handleRetry]);
};

export default useFetchLookupData;
